import {SharedQuestion} from "./SharedQuestion";
import {SelectSharedQuestion} from "./SelectSharedQuestion";

export class SelectNumericSharedQuestion extends SelectSharedQuestion {

    // @TODO:
    // satisfiesLogic(node:ILogicNode):boolean {
    //     const value = this.getValue().value;
    //     const nodeValue = node.value;
    //     const valueFrom = node.valueFrom;
    //     const valueTo = node.valueTo;
    //
    //     if (nodeValue && nodeValue === value) {
    //         return true;
    //     }
    //
    //     if (valueFrom && valueTo && value >= valueFrom && value <= valueTo) {
    //         return true;
    //     }
    //
    //     if (valueFrom && !valueTo && value >= valueFrom) {
    //         return true;
    //     }
    //
    //     if (!valueFrom && !valueTo && value <= valueTo) {
    //         return true;
    //     }
    //
    //     return false;
    // }

}